module.exports = __webpack_public_path__ + "static/media/CooperHewitt-Book.4d987dcb.woff2";